module.exports = __webpack_public_path__ + "img/welcone.394e1456.png";